<template lang="pug">
	#page
		navmain
		transition(name="fade" mode="out-in")
			router-view(class="view" :key='$route.path')
		overlayer
		navfooter
</template>

<script>
import anime from 'animejs';
import store, {ABSPATH} from '@/store';
import navmain from '@/components/features/Navmain/';
import navfooter from '@/components/features/Navfooter/';
import overlayer from '@/components/Overlayer';

export default {
	name: 'app',
	data () {
		return {
			dom: {
				overlayer: {}
			}
		}
	},
	created(){
		this.fetchData()
	},
	components: {
		navmain,
		navfooter,
		overlayer
	},
	methods: {
		fetchData(){
			if (!store.state.loadedSetup){
				// console.log('state');
				fetch(`${ABSPATH}/api/v1/setup`)
					.then( response => response.json() )
					.then( body => {
						store.commit('insertSetup', body)
					})
					.catch( (error) => {console.log('error', error); })
			}
		},
		winScrollTo(to) {
			let scrollType = typeof to === 'object' ? to.offsetTop : to;
			let scrollAnim = anime({
				targets: 'html, body',
				scrollTop: scrollType,
				duration: 900,
				easing: 'easeInOutQuart'
			});
		},
		openOverlayer() {
			this.dom.overlayer.classList.add('overlayer--show');
			document.body.classList.add('is-overlayer');
		},
		closeOverlayer() {
			this.dom.overlayer.classList.remove('overlayer--show');
			document.body.classList.remove('is-overlayer');
		}
	},
	mounted() {
		this.dom.overlayer = this.$el.querySelector('.overlayer');
	}
}

</script>

<style lang="sass">
	.fade-enter-active, .fade-leave-active
		transition: opacity .35s
	.fade-enter, .fade-leave-to
		opacity: 0
</style>



// WEBPACK FOOTER //
// src/App.vue